import { useSyncExternalStore } from "react";
import { editToken } from "./editToken";

// Reactive view over the per-user edit token (warurna:userToken, owned by
// editToken). A module-level store so the nav account menu, the candidacy page,
// and poll-vote dedup all see verification state change live — no reload — and
// stays in sync across tabs via the storage event. editToken remains the storage
// source of truth (key, format, legacy migration); this only adds reactivity.

let current: string | null = editToken.getUser();
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (e: StorageEvent) => {
    if (e.key === "warurna:userToken") {
      current = editToken.getUser();
      emit();
    }
  });
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

/** Store + activate a per-user token (after verify, or a paste-to-restore). */
export function setUserToken(token: string): void {
  editToken.setUser(token);
  current = token;
  emit();
}

/** Forget the per-user token on this device. */
export function clearUserToken(): void {
  editToken.clearUser();
  current = null;
  emit();
}

/** Re-read from storage (e.g. after a legacy per-candidacy token migrates). */
export function refreshUserToken(): string | null {
  const t = editToken.getUser();
  if (t !== current) {
    current = t;
    emit();
  }
  return current;
}

export function useUserToken(): string | null {
  return useSyncExternalStore(subscribe, () => current, () => current);
}
